import { Component, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';

import { StyleService } from 'app/services';

@Component({
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnDestroy {

  constructor(
    private location: Location,
    private styleService: StyleService
  ) {
  }

  ngOnDestroy(): void {
  }

  back() {
    this.location.back();
  }
}
